export default {
  name: "editor",
  class: "icon icon-tabler icon-tabler-x",
  box: 24,
  svg: `<path stroke="none" d="M0 0h24v24H0z" stroke-width="2.5"
  stroke="fillcolor"
  stroke-linecap="round"
  stroke-linejoin="round" />
  <line x1="18" y1="6" x2="6" y2="18" />
  <line x1="6" y1="6" x2="18" y2="18" />`,
};
